import axios from 'axios';
import { getTokenData, removeToken } from '../utils/token';

const SERVER_API = process.env.SERVER_API;

const serverApi = axios.create({
  baseURL: SERVER_API
});

export const serverApiWithAuth = axios.create({
  baseURL: SERVER_API
});

serverApiWithAuth.interceptors.request.use(
  requestConfig => {
    const tokenData = getTokenData();
    return tokenData
      ? {
          ...requestConfig,
          headers: {
            ...requestConfig.headers,
            'X-Easyvote-Access-Token': tokenData.token
          }
        }
      : requestConfig;
  },
  error => Promise.reject(error)
);

serverApiWithAuth.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    error && error.response && error.response.status === 401 && removeToken();
    const errMessage = error.response && error.response.data && error.response.data.error.message;
    return Promise.reject(errMessage || error.response || error.request || error.message);
  }
);

serverApi.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error.response || error.request || error.message)
);

export default serverApi;
